import type {MouseEvent, ReactElement} from 'react';
import React, {useState} from 'react';
import {Text, TextSize} from '@Components/text';
import styles from './ai-image-tooltip-text.module.scss';
import {copyToClipboard} from '@Utils/clipboard.util';
import {GA4EventName, trackPosterBuilderGA4Events} from '@Libraries/ga-events';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

interface AiImageTooltipTextProps {
  prompt: string;
}

export function AiImagePromptText({...props}: AiImageTooltipTextProps): ReactElement<any> {
  const [isCopiedClicked, setIsCopiedClicked] = useState(false);
  const onCopy = (e: MouseEvent): void => {
    e.preventDefault();
    e.stopPropagation();
    void copyToClipboard(props.prompt);
    trackPosterBuilderGA4Events(GA4EventName.AI_IMAGE_PROMPT_COPY);
    setIsCopiedClicked(true);

    setTimeout(() => {
      setIsCopiedClicked(false);
    }, 2000);
  };

  const prepareCopyPromptContentForAIImage = (): ReactElement<any> => {
    return (
      <div className={`spacing-p-2 flexbox flex-align-items-center ${styles.container}`}>
        <OverlayTrigger
          trigger={['hover', 'focus']}
          placement="top"
          show={isCopiedClicked}
          overlay={
            <Tooltip className={`spacing-m-b-1 _rounded-arrow`}>
              <Text size={TextSize.XSMALL} className="content-body-white" val={window.i18next.t('pmwjs_copied')} />
            </Tooltip>
          }
          delay={{show: 0, hide: 0}}
        >
          <Icon icon={'icon-copy'} size={IconSize.SIZE_ICON_16} onClick={onCopy} className={'content-body-white spacing-m-r-1'} />
        </OverlayTrigger>
        <Text size={TextSize.XSMALL} className={`content-body-white spacing-m-l-1 ${styles.prompt}`} val={props.prompt} />
      </div>
    );
  };

  return prepareCopyPromptContentForAIImage();
}
